export const AuditAttributes = {
  "transactionAtrributes": {
    fullName: "Name",
    city: "City",
    office: "Office",
    floor: "Floor",
    gate: "Gate",
    transportationMode: "Transportation Mode",
    taxiProvider: "Taxi Provider",
    vehicleType: "Vehicle Type",
    rideType: "Ride Type",
    vehicleNumber: "Vehicle Number",
    others: "Other",
    exitDate: "Exit Date",
    exitTime: "Exit Time",
    shiftSupervisor: "Shift Supervisor",
    employeeType: "Employee Type"
  },
  "userAttribute": {
    cityId: "City",
    RoleName: "Role",
    isActive: "Status",
    offices: "Office"
  },
  "officeAttribute": {
    floor: "Floor",
    gate: "Gate",
    status: "Status"
  },
  "auditData": {
    modified: "Modified",
    deleted: "Deleted"
  },
  "tableName": {
    gate: "Gate",
    user: "ApplicationUser",
    consent:"Consent",
    city:"City"
  },
  "status": {
    InActive: "InActive",
    Active: "Active"
  },
  "consent": {
    consent: "Consent",

  }
} 